import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Dashboard.css';
import Dashboard from '../../components/Dashboard';

const Progressbar = () => {
  return (
    <>
      <Dashboard />
    </>
  );
};

Progressbar.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s)(Progressbar);
